export default "__VITE_ASSET__B_29W2JR__"